document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('slider-component[data-product-dots]').forEach(function (component) {
    const slider = component.querySelector('.product__media-list.slider');
    const dotsWrap = component.querySelector('[data-product-dots-nav]');

    if (!slider || !dotsWrap) return;

    function getVisibleSlides() {
      return Array.from(component.querySelectorAll('.product__media-item.slider__slide'))
        .filter(slide => !slide.classList.contains('hide-image'));
    }

    function buildDots() {
      const visibleSlides = getVisibleSlides();

      // Hide dots if 0 or 1 visible slide
      if (visibleSlides.length <= 1) {
        dotsWrap.innerHTML = '';
        dotsWrap.style.display = 'none';
        return;
      }

      dotsWrap.style.display = '';
      dotsWrap.innerHTML = '';

      visibleSlides.forEach((slide, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-slider-dot';
        btn.dataset.index = String(i);
        btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dotsWrap.appendChild(btn);
      });

      setActiveFromScroll();
    }

    function setActive(index) {
      const dots = dotsWrap.querySelectorAll('.product-slider-dot');
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    function goToVisibleSlide(index) {
      const visibleSlides = getVisibleSlides();
      const target = visibleSlides[index];
      if (!target) return;

      slider.scrollTo({
        left: target.offsetLeft,
        behavior: 'smooth'
      });

      setActive(index);
    }

    function setActiveFromScroll() {
      const visibleSlides = getVisibleSlides();
      if (!visibleSlides.length) return;

      let closestIdx = 0;
      let minDist = Infinity;

      visibleSlides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - slider.scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closestIdx = i;
        }
      });

      setActive(closestIdx);
    }

    // Dot click
    dotsWrap.addEventListener('click', function (e) {
      const dot = e.target.closest('.product-slider-dot');
      if (!dot) return;
      const i = Number(dot.dataset.index || 0);
      goToVisibleSlide(i);
    });

    // Update active dot on scroll/swipe
    let scrollTimeout;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(setActiveFromScroll, 80);
    });

    // Rebuild dots whenever slides become hidden/shown (variant change toggles classes)
    const observer = new MutationObserver(function () {
      buildDots();
    });

    observer.observe(slider, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class']
    });

    // Initial build
    buildDots();
  });
});